<template>
    <div class="login-logo-container">
        <div class="login-logo-wrapper relative">
            <div class="bg-purple">
                <inline-svg src="/assets/images/halbkreis-lila_2.svg" alt="" class="attachment-large size-large" ></inline-svg>
            </div>
            <div class="logo-white">
                <a href="https://toolbox.gizmorilla.com/">
                    <!--<img width="600" height="400" src="/assets/images/gizmorilla_white.svg" class="attachment-full size-full" alt="Gizmorillanin Logosu - bir goril kafasi ve ünvani">-->
                    <inline-svg src="/assets/images/gizmorilla_eu_white.svg" width="600" height="400" alt="Gizmorilla Logo" class="attachment-full size-full" ></inline-svg>
                </a>
            </div>
        </div>
    </div>

    <div class="col flex-grow-1 custom-col-1 col-lg-8 col-md-6 col-12 align-items-center p-5 primary-bg no-displayer top-position-tablet left-content">
        <div class="row justify-content-lg-start justify-content-center pb-4 pb-sm-0 h-100">
            <div class="col-xl-6 col-l-5 col-lg-6 col-sm-10 col-xs-12 col-12 align-self-start align-self-lg-center ">
                <h2 class="new-first-headline">{{ $t('left-content.headline1') }}</h2>
                <h3 class="new-second-headline">{{ $t('left-content.headline2') }}</h3>
                <p class="new-third-headline">{{ $t('left-content.introText') }}</p>

                <p class="text-left">
                    <a href="{{ $t('login.to_landing_page_url') }}" class="btn btn-secondary btn-block text-center slide-btn min-width-btn">
                        {{ $t('login.to_landing_page') }}
                    </a>
                </p>
            </div>
        </div>
        <p class="legal-links">
            {{ $t('copyright', {year: year}) }} |
            <a v-on:click="$popup.open($event,$t('footer.tos.file'))">{{ $t('footer.tos.title') }}</a> |
            <a v-on:click="$popup.open($event,$t('footer.privacy_policy.file'))">{{ $t('footer.privacy_policy.title') }}</a> |
            <a v-on:click="$popup.open($event,$t('footer.imprint.file'))">{{ $t('footer.imprint.title') }}</a></p>
    </div>

    <div class="p-5 img-wrapper-ipad">
        <img class="img-ipad" src="/assets/images/tablet-main.png"/>
        <img class="img-dots" src="/assets/images/purple-dots-1.png" />
        <img class="img-woman" src="/assets/images/woman-happy-yellow-top.png" />
        <img class="img-man" src="/assets/images/man-smiling-bg-red.png" />
        <img class="img-triangles" src="/assets/images/triangles.png" />
        <img class="img-blue-circle" src="/assets/images/circle-blue-partly.png" />
    </div>
</template>

<script>
//    import moment from 'moment';
    export default {
        name: 'loginleft',
        data(){
            return{
            };
        }
        ,created(){
            
        }
        ,mounted() {
        }
        ,methods: {

        }
    }
</script>